<template>
  <div class="container-fluid h-100">
    <div class="container mt-5 pt-5">

      <div class="row mt-5 pt-3">
        <div class="col-12">
          <h4 class="text-left text-dark font-weight-bold">
            Redenciones del producto: <label style="color: #dc3545"> {{ productId }} - {{ productName }} </label>
          </h4>
        </div>
        <div class="col-12">
          <h4 class="text-left text-dark font-weight-bold">
            Cantidad total de redenciones: <label style="color: #dc3545">{{ totalItems }}</label>
          </h4>
        </div>
        <div class="col-12">
          <h4 class="text-left text-dark font-weight-bold">
            Pendientes de entrega: <label style="color: #dc3545">{{ totalItemsPending }}</label> - Entregados: <label style="color: #dc3545">{{ totalItemsDelivered }}</label> - Rechazados: <label style="color: #dc3545">{{ totalItemsRejected }}</label>
          </h4>
        </div>
        <div class="col-lg-5 col-9 mt-2">
          <input
            v-model="searchN"
            type="text"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder="Buscar orden"
            autocomplete="not"
            v-on:focus="clearInput"
          />
        </div>            
        <div class="col-lg-1 col-3 mt-2">
          <button class="btn btn-danger btn-block" @click="getRedemptions()">
            <span class="fa fa-search m-0 p-0" aria-hidden="true"></span>
          </button>
        </div>
        <div class="col-lg-3 col-12 mt-2">
          <button class="btn btn-info btn-block" @click="downloadReport()">
            Reporte de producto
          </button>
        </div>
        <!-- <div class="col-3 mt-2">
          <button class="btn btn-info btn-block" @click="downloadReport1()">
            Reporte total de redenciones
          </button>
        </div> -->
      </div>

      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </template>

      <paginate
        v-else
        class="ul-pagination"
        name="items"
        :list="items"
        :per="10"
      >
        <div class="row mt-1">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-striped table-sm">
                <caption class="visually-hidden">Listado de Ordenes</caption>
                <thead>
                  <tr>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Id</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Fecha Orden</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Orden</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Cliente</th>
                    <!-- <th scope="col" style="text-align:left; white-space:nowrap;">Dirección</th> -->
                    <th scope="col" style="text-align:left; white-space:nowrap;">Departamento</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Ciudad</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">E-Mail</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Teléfono</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Estado</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Registrar entrega</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Rechazar entrega</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Agregar número de guía</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Proveedor</th>
                    <th scope="col" style="text-align:left; white-space:nowrap;">Número de guía</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in paginated('items')"
                    :key="'d' + `item-${i}`"
                  >
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.id }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.created_at }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order_id }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order.users ? item.order.users.name : ''}} {{ item.order.users ? item.order.users.last_name : ''}}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order.users ? item.order.users.city.states.name : '' }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order.users ? item.order.users.city.name : '' }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order.users ? item.order.users.email : '' }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      {{ item.order.users ? item.order.users.phone : '' }}
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      <label v-if="item.status_id == 4" style="color:#5F9DF7">
                        {{ item.estado }}
                      </label>
                      <label v-else-if="item.status_id == 6" style="color:#43cb28">
                        {{ item.estado }}
                      </label>
                      <label v-else style="color:#dc3545">
                        {{ item.estado }}
                      </label>
                    </td>
                    <td style="text-align:center; white-space:nowrap;">
                      <input
                        v-if="item.status_id == 4"
                        type="checkbox" 
                        :value="item.id" 
                        v-model="deliveryProducts" 
                        :disabled="rejectedProducts.includes(item.id)" 
                        @change="showVerification(item.id)"
                      />
                    </td>
                    <td style="text-align:center; white-space:nowrap;">
                      <input
                        v-if="item.status_id == 4"
                        type="checkbox" 
                        :value="item.id" 
                        v-model="rejectedProducts" 
                        :disabled="deliveryProducts.includes(item.id)" 
                        @change="showVerification1(item.id)"
                      />
                    </td>
                    <td style="text-align:center; white-space:nowrap;">
                      <button
                        class="btn btn-danger"
                        data-toggle="modal"
                        data-target="#showModal"
                        @click="getRecord(item.id, item.order.users.email)"
                      >
                        <span class="fa-solid fa-truck"></span>
                      </button>
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      <strong v-if="item.supplier_name">{{ item.supplier_name }}</strong>
                      <span v-else>Sin información de proveedor</span>
                    </td>
                    <td style="text-align:left; white-space:nowrap;">
                      <strong v-if="item.tracking_number">{{ item.tracking_number }}</strong>
                      <span v-else>Sin número de guía</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </paginate>

      <div class="row ">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-4 pl-md-5 pl-xl-2"
        >
          <label class="text-p"> Página {{ page }} de {{ totalPage }} </label>
        </div>
        <div
          class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-4 center-paginate"
        >
          <paginate-links
            @change="pageChange"
            for="items"
            :limit="2"
            :show-step-links="true"
            :step-links="{ next: '>', prev: '<' }"
            :classes="{ ul: 'pagination', li: 'page-item', a: 'page-link' }"
          >
          </paginate-links>
        </div>
      </div>

      <div style="margin:auto 0px auto auto;" class="col-2" v-if="BtnUpdateRecords == true">
        <button @click="updateRecords()" class="btn btn-success btn-block">
          Actualizar registros
        </button>
      </div>

      <div class="col-1 mt-2">
        <button class="btn btn-danger btn-block" @click="back()">
          Atrás
        </button>
      </div>
    </div>

    <!-- Modal para agregar proveedor y número de guía -->
    <div 
      class="modal fade" 
      id="showModal" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="exampleModalCenterTitle" 
      aria-hidden="true"
    >
      <div 
        class="modal-dialog modal-dialog-centered" 
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Actualizar información de envío
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <select 
                  class="form-control"
                  v-model="form.supplier_name"
                >
                  <option disable value="">Seleccionar proveedor</option>
                  <option value="Envía">Envía</option>
                  <option value="Servientrega">Servientrega</option>
                  <option value="Interrapidisimo">Interrapidisimo</option>
                </select>
              </div>
              <div class="form-group">
                <input 
                  type="text" 
                  class="form-control" 
                  placeholder="Número de guía"
                  v-model="form.tracking_number"
                >
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button 
              type="button" 
              class="btn btn-danger" 
              data-dismiss="modal"
              @click="resetForm"
            >
              Cerrar
            </button>
            <button 
              type="button" 
              class="btn btn-primary"
              @click="addTracking"
            >
              <span v-if="loading.update">
                Actualizando <span class="fa fa-spinner fa-spin"></span>
              </span>
              <span v-else>
                Actualizar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import $ from "jquery";
import * as XLSX from 'xlsx';
import axios from 'axios';

export default {
  data() {
    return {
      arrayProducts: [],
      arrayProductsTotal: [],
      productId: null,
      productName: null,
      productSku: null,
      totalItems: 0,
      totalItemsDelivered: 0,
      totalItemsRejected: 0,
      totalItemsPending: 0,
      item: null,
      itemsAll: [],
      searchN: "Buscar orden",
      form: {
        id: 0,
        userEmail: "",
        supplier_name: "",
        tracking_number: ""
      },
      loading: {
        history: false,
        update: false
      },
      hidden: {
        btn: false
      },
      items: [],
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      isWon: false,
      deliveryProducts: [],
      rejectedProducts: [],
      BtnUpdateRecords: false,
    };
  },
  methods: {
    back(){
      window.history.back();
    },
    search() {
      this.items = [];
      this.loading.history = true;
      axios
        .get("superAdmin/product/moto/" + this.searchN)
        .then(res => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 10);
          }
          this.loading.history = false;
        })
        .catch(error => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message
          });
        });
    },
    showVerification(item){
      const productId = parseInt(item.value);
      this.rejectedProducts = this.rejectedProducts.filter(id => id !== productId);
      if (item.checked) {
        this.deliveryProducts.push(productId);
      } else {
        const index = this.deliveryProducts.indexOf(productId);
        if (index > -1) {
          this.deliveryProducts.splice(index, 1);
        }
      }
      if(this.deliveryProducts.length > 0){
        this.BtnUpdateRecords = true;
      } else {
        if(this.rejectedProducts.length == 0){
          this.BtnUpdateRecords = false;
        }
      }
      // console.log('deliveryProducts ', JSON.stringify(this.deliveryProducts));
    },
    showVerification1(item){
      const productId = parseInt(item.value);
      this.deliveryProducts = this.deliveryProducts.filter(id => id !== productId);
      if (item.checked) {
        this.rejectedProducts.push(productId);
      } else {
        const index = this.rejectedProducts.indexOf(productId);
        if (index > -1) {
          this.rejectedProducts.splice(index, 1);
        }
      }
      if(this.rejectedProducts.length > 0){
        this.BtnUpdateRecords = true;
      } else {
        if(this.deliveryProducts.length == 0){
          this.BtnUpdateRecords = false;
        }
      }
      // console.log('rejectedProducts ', JSON.stringify(this.rejectedProducts));
    },
    updateRecords(){   
      if (this.deliveryProducts.length > 0) {
        axios
          .post('api/moto/stock/setDeliveryOrderProduct/' + this.deliveryProducts)
          .then(async res => {
            if (res.data.cod == 0) {
              await this.getRedemptions()
              if (this.rejectedProducts.length == 0) {
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "success",
                  title: "Muy bien",
                  text: res.data.message,
                });
                this.deliveryProducts = [];
              }
            }
            this.BtnUpdateRecords = false;
            if (this.rejectedProducts.length == 0) {
              this.loading.history = false;
            }
            this.deliveryProducts = [];
          })
          .catch(error => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      }

      if (this.rejectedProducts.length > 0) {
        axios
          .post(`api/moto/stock/cancelDeliveryOrderProduct/${this.rejectedProducts}`)
          .then(async res => {
            if (res.data.cod == 0) {
              await this.getRedemptions()
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
            }
            this.rejectedProducts = [];
            this.BtnUpdateRecords = false;
            this.loading.history = false;
          })
          .catch(error => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message
            });
          });
      }
    },
    getRedemptions() {
      this.totalItemsDelivered = 0;
      this.totalItemsPending = 0;
      this.totalItemsRejected = 0;
      this.items = [];
      this.loading.history = true;
      axios
        .get(`api/moto/stock/getProductRedemption/${this.productId}/${this.searchN == 'Buscar orden' || this.searchN == '' ? '0' : this.searchN}`)
        .then(res => {
          if (res.data.cod == 0) {
            let aux = res.data.data;
            // this.items = res.data.data;
            
            // console.log(JSON.stringify(this.items));
            // console.log(`this.items: ${JSON.stringify(aux)} ` );
            aux.map(opc =>{
              if(opc.order && opc.order.users){
                this.items.push(opc)
              }
            })
            this.totalPage = Math.ceil(parseInt(this.items.length) / 10);
            this.totalItems = this.items.length

            this.items.forEach(element => {
              if(element.status_id == 6){
                this.totalItemsDelivered++
              }else if(element.status_id == 4){
                this.totalItemsPending++
              }else{
                this.totalItemsRejected++
              }
            });
            
          }

          this.items.map(item => {
            if(item.status_id == 4){
              item.estado = "Pendiente entrega"
            }
            else if(item.status_id == 6){
              item.estado = "Entregado"
            }else if(item.status_id == 7){
              item.estado = "Rechazado"
            }
          });
          
          this.loading.history = false;
        })
        .catch(error => {
          //console.log(`Este es el puto error ${JSON.stringify(error)}`);
          console.log(error);
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: 'Error obteniendo información'
          });
        });
    },
    downloadReport(){
      this.$swal({
        title: `Reporte de ordenes del producto`,
        text: `${this.productName}`,
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "Reporte completo",
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#1da5df",
        confirmButtonText: "Solo pendientes de entrega",
      }).then( (result) => {
        this.arrayProducts = [];
        if (result.value) {
          this.items.forEach((item) => {
            if(item.order.users && (item.status_id == 4 || item.status_id == 7)){
              this.arrayProducts.push({
                Id:item.id,
                Orden:item.order_id,
                Nombres:item.order.users.name,
                Apellidos:item.order.users.last_name,
                Celular:item.order.users.phone,
                Documento:item.order.users.document_number,
                Email:item.order.users.email,
                Departamento:item.order.users.city.states.name,
                Ciudad:item.order.users.city.name,
                Direccion:item.order.users.address,
                Direccion_Centro_Acopio:item.order.users.collect_cent_address,
                Datos_adicionales:item.order.users.aditional,
                Fecha_registro:item.created_at,
                Producto:this.productName,
                Sku:this.productSku,
                Talla:item.size.name,
                Estado:item.estado
              });
            }
          });
        } else {
          this.items.forEach((item) => {
            if(item.order.users){
              this.arrayProducts.push({
                Id:item.id,
                Orden:item.order_id,
                Nombres:item.order.users.name,
                Apellidos:item.order.users.last_name,
                Celular:item.order.users.phone,
                Documento:item.order.users.document_number,
                Email:item.order.users.email,
                Departamento:item.order.users.city.states.name,
                Ciudad:item.order.users.city.name,
                Direccion:item.order.users.address,
                Direccion_Centro_Acopio:item.order.users.collect_cent_address,
                Datos_adicionales:item.order.users.aditional,
                Fecha_registro:item.created_at,                
                Producto:this.productName,
                Sku:this.productSku,
                Talla:item.size.name,
                Estado:item.estado
              });
            }
          });
        }
        const data = XLSX.utils.json_to_sheet(this.arrayProducts);
        const workbook = XLSX.utils.book_new();
        const filename = 'RedencionesProducto';
        XLSX.utils.book_append_sheet(workbook, data, filename);
        XLSX.writeFile(workbook, `${filename}.xlsx`);
      });
    },
    downloadReport1() {
      this.itemsAll = [];
      this.loading.history = true;
      axios
        .get(`api/moto/stock/getFullProductRedemption`)
        .then(res => {
          if (res.data.cod == 0) {
            this.itemsAll = res.data.data;
            this.itemsAll.map(item => {
              if(item.status_id == 4){
                item.estado = "Pendiente entrega"
              }
              else if(item.status_id == 6){
                item.estado = "Entregado"
              }else if(item.status_id == 7){
                item.estado = "Rechazado"
              }
            });
            this.$swal({
              title: `Reporte de ordenes completo`,
              text: `¿Que tipo de reporte desea?`,
              icon: "info",
              showCancelButton: true,
              confirmButtonText: "Solo pendientes de entrega", // 1
              confirmButtonColor: "#1da5df",
              cancelButtonText: "Reporte completo", // 2
              cancelButtonColor: "#dc3545",
            }).then( (result) => {
              if (result.value) {
                this.downloadReport2(1);
              }else{
                this.downloadReport2(2);
              }
            });
          }
          this.loading.history = false;
        })
        .catch(() => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: 'Error generando el reporte'
          });
        });
    },
    downloadReport2(opc){
      this.arrayProductsTotal = [];
      if(opc == 1){
        this.itemsAll.forEach((item) => {
          if(item.order && item.order.users && item.status_id == 4){
            if(!item.product.name.toUpperCase().includes("BONO")){
              this.arrayProductsTotal.push({
                Id:item.id,
                Orden:item.order_id,
                Nombres:item.order.users.name,
                Apellidos:item.order.users.last_name,
                Celular:item.order.users.phone,
                Documento:item.order.users.document_number,
                Email:item.order.users.email,
                Departamento:item.order.users.city.states.name,
                Ciudad:item.order.users.city.name,
                Direccion:item.order.users.address,
                Direccion_Centro_Acopio:item.order.users.collect_cent_address,
                Datos_adicionales:item.order.users.aditional,
                Fecha_registro:item.created_at,
                Producto:item.product.name,
                Sku:item.product.sku,
                Talla:item.size.name,
                Estado:item.estado
              });
            }
          }
        });
      } else {
        this.itemsAll.forEach((item) => {
          if(item.order && item.order.users && (item.status_id == 4 || item.status_id == 6 || item.status_id == 7)){
            if(!item.product.name.toUpperCase().includes("BONO")){
              this.arrayProductsTotal.push({
                Id:item.id,
                Orden:item.order_id,
                Nombres:item.order.users.name,
                Apellidos:item.order.users.last_name,
                Celular:item.order.users.phone,
                Documento:item.order.users.document_number,
                Email:item.order.users.email,
                Departamento:item.order.users.city.states.name,
                Ciudad:item.order.users.city.name,
                Direccion:item.order.users.address,
                Direccion_Centro_Acopio:item.order.users.collect_cent_address,
                Datos_adicionales:item.order.users.aditional,
                Fecha_registro:item.created_at,
                Producto:item.product.name,
                Sku:item.product.sku,
                Talla:item.size.name,
                Estado:item.estado
              });
            }
          }
        });
      }
      const datar = XLSX.utils.json_to_sheet(this.arrayProductsTotal);
      const workbook = XLSX.utils.book_new();
      const filename = 'RedencionesCompletas';
      XLSX.utils.book_append_sheet(workbook, datar, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    pageChange(toPage) {
      this.page = toPage;
    },
    clearInput() {
      this.searchN = "";
    },
    getRecord(orderId, userEmail){
      this.form.id = orderId;
      this.form.userEmail = userEmail;
    },
    addTracking(){
      this.loading.update = true;
      if(!this.form.supplier_name.trim() || !this.form.tracking_number.trim()){
        this.$swal({
          icon: "error",
          title: "Oops!",
          html: "<span>El <strong>Proveedor</strong> y el <strong>Número de guía</strong> son obligatorios.</span>",
          confirmButtonColor: "#dc3545"
        });
        this.loading.update = false;
        return false;
      } else {
        axios
          .patch('superAdmin/add-tracking-number', this.form)
          .then(response => {
            console.log('response ', JSON.stringify(response));
            this.loading.update = false;
            if(response.data.cod == 0){
              this.$swal({
                icon: "success",
                title: "¡Excelente!",
                text: response.data.message,
                confirmButtonColor: "#dc3545"
              });
            }
            this.resetForm();
            $('#showModal').modal('hide');
            this.getRedemptions();
          })
          .catch(error => {
            this.loading.update = false;
            // console.log('error ', JSON.stringify(error));
            this.$swal({
              icon: "error",
              title: "Oops!",
              text: "Ocurrió un error actualizando la orden",
              confirmButtonColor: "#dc3545"
            });
            this.resetForm();
          });
      }
    },
    resetForm() {
      this.form = {
        id: 0,
        supplier_name: "",
        tracking_number: ""
      };
    },
  },
  mounted() {
    this.productId = this.$route.params.productId
    this.productName = this.$route.params.productName
    this.productSku = this.$route.params.productSku
    this.pageChange(1);
    this.getRedemptions();
  },
};
</script>

<style scoped>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.container{
  max-width: 95%;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
